import dynamic from 'next/dynamic';
import React from 'react';
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface LottieAnimationProps {
  animationData: any;
  width?: number;
  height?: number;
  mountAnimation?: boolean;
  unmountAnimation?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  onComplete?: () => void;
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  width,
  height,
  mountAnimation = true,
  unmountAnimation = true,
  loop = false,
  autoplay = true,
  onComplete,
}) => {
  return (
    <Lottie
      width={width}
      height={height}
      loop={loop}
      autoplay={autoplay}
      onComplete={onComplete}
      animationData={animationData}
      style={{ width, height }}
    />
  );
};

export default LottieAnimation;
